import React from "react";
import {StyleSheet, Text, View, ImageBackground, ScrollView, TouchableOpacity} from 'react-native';
import Acording from "../components/Acording";
import {RFValue} from "react-native-responsive-fontsize";

import { Ionicons } from '@expo/vector-icons';

import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Config from "../components/Config";
const Friends = ({navigation})=>{

    let [list,Setlist] = React.useState([]);


    React.useEffect(()=>{
        getData();
    },[]);


    const getData = async ()=>{
        let token = await AsyncStorage.getItem('token');



        let res = await axios.get(
            `${Config.base}/api/v1/referral`,
            { params:
                    {
                        token: token
                    }
            }
        );


        let dlist = res.data.list;

        Setlist(dlist);
        list = dlist;


    };


    return (
        <View style={{flex : 1}}>
            <ImageBackground
                // source={require('../assets/friends.jpg')}
                source={{uri:'https://metamax.network/public/appBg.jpg'}}
                resizeMode="cover" style={{flex : 1}}>
                <Text style={styles.header}>
                    <TouchableOpacity style={{ backgroundColor : 'transparent'}} onPress={()=>navigation.goBack()}>
                        <Ionicons   name="return-up-back" size={RFValue(35)} color="#FFF" />
                    </TouchableOpacity>
                    {`   `}
                    Friends
                </Text>

                {list.length > 0 ?
                    <ScrollView style={{paddingHorizontal : RFValue(8)}}>
                        {list.map((item ,index) =>
                            <Acording master={1} key={index} name={item.name} list={item.list} avatar={item.avatar}></Acording>
                        )}
                    </ScrollView>
                    :
                    <>

                        <Text style={styles.header}>
                            No friend !
                        </Text>

                    </>
                }



            </ImageBackground>

        </View>
    );
}


const styles = StyleSheet.create({
    text : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(15),
        padding : RFValue(10),
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3
    },
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(35),
        padding : RFValue(25),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,


    }
});


export default Friends;
